import { useEffect } from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';
import CardItem from './CardItem';
import { useDuplicateUid } from './ContextAPI';

export default function CardList() {
    const { groups, loading, totalGroups, fetchGroups } = useDuplicateUid();

    useEffect(() => {
        fetchGroups();
    }, [fetchGroups]);

    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" /> <span className="ms-2">Loading duplicate groups...</span>
            </div>
        );
    }

    if (!groups || groups.length === 0) {
        return <Alert variant="success" className="text-center">🎉 No duplicate UID found — all codes are unique!</Alert>;
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Found <b>{totalGroups}</b> duplicate code groups</h6>
                <Button variant="outline-secondary" size="sm" onClick={fetchGroups}>Refresh</Button>
            </div>
            <div className="card-list">
                {groups.map((g) => (
                    <CardItem key={g.code_no} group={g} onUpdated={fetchGroups} />
                ))}
            </div>
        </>
    );
}
